import React, { Component } from "react";
import { connect } from "react-redux";
import Dropdown from "../../components/Dropdown/Dropdown";
import Aux from "../Hoc/Hoc";
import TemplateProducts from "../../components/TemplateProducts/TemplateProducts";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import * as calculatorActions from "../../store/actions/index";
import * as actionTypes from "../../store/actions/actionTypes";
import OverviewModal from "../../components/OverviewModal/OverviewModal";

import Spinner from "../../components/Spinner/Spinner";

class Calculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "",
      selectedOptionDescription: "",
      currentM2asked: 1,
      waste: 0.05,
      currentAlternativeDescription: "",
      email:""
    };
  }

  async componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.props.onLoadProducts();
    this.props.onLoadTemplates(1);
    //this.props.onLoadAlternativeOptions(1);
  };

  handleOnChange = event => {
    this.props.onLoadAlternativeOptionsTemplate(event.target.value);
    this.props.onLoadCurrentTemplateProducts(event.target.value);

    this.setState({
      selectedOption: this.props.templates[event.target.value].nombre,
      selectedOptionDescription: this.props.templates[event.target.value]
        .description,
      currentAlternativeDescription: this.props.templates[event.target.value]
        .alternativeDescription
    });
  };

  handleOnChangeM2Asked = event => {
    this.setState({ currentM2asked: event.target.value });
  };

  setDescriptionTemplate = title => {
    return <span>{title}</span>;
  };

  handleOnChangeEmail = event => {
    console.log(event.target.value);
    //setEmail(event.target.value);
    this.setState({ email: event.target.value });
  };

  render() {
    const modal = {
      padding: "10px"
    };

    //AGREGAR Description
    let dropdown = this.props.templates ? (
      <div>
        <Dropdown
          placeholder={"Selecciona el template..."}
          options={this.props.templates}
          handleOnChange={this.handleOnChange}
        />
      </div>
    ) : null;

    let productsTemplate =
      this.props.alternativeOptionsTemplate.length !== 0 &&
      this.props.currentTemplateProducts.length !== 0 ? (
        <TemplateProducts
          products={this.props.currentTemplateProducts.filter(
            p => !p.isAlternativeProduct
          )}
          desperdicio={this.state.waste}
          m2Solicitados={this.state.currentM2asked}
          alternativeProducts={this.props.alternativesTemplateProducts}
          updateProducts={this.props.onUpdateCurrentTemplateProducts}
          alternativeOption={this.props.alternativeOptionsTemplate}
          updateTemplateOptions={this.props.onUpdateCurrentTemplateOptions}
          altDescription={this.state.currentAlternativeDescription}
          email={this.state.email}
          templateSelected={this.state.selectedOption}
          alternativeDescription={this.state.currentAlternativeDescription}
        />
      ) : (
        <p1>Por favor seleccione un template...</p1>
      );
    return (
      <Aux>
        <Container>
          <img
            style={{ width: "50%" }}
            src="/img/perfile.jpg"
            alt="/img/perfile.jpg"
          />
          {dropdown}
          <div>
            <TextField
              id="outlined-with-placeholder"
              label="Cantidad de m2"
              placeholder="Cantidad de m2"
              margin="normal"
              variant="outlined"
              defaultValue="1"
              onChange={this.handleOnChangeM2Asked}
            />
          </div>
          <div>
            <h1>{this.state.selectedOption}</h1>
            <span>{this.state.selectedOptionDescription}</span>
            {productsTemplate}
          </div>
        </Container>
        <OverviewModal
          style={modal}
          currentM2asked={this.state.currentM2asked}
          email={this.state.email}
          handleOnChangeEmail={this.handleOnChangeEmail}
        />
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    products: state.products,
    templates: state.templates,
    currentTemplateProducts: state.currentTemplateProducts,
    alternativesTemplateProducts: state.alternativesTemplateProducts,
    currentTemplateID: state.currentTemplateID,
    alternativeOptionsTemplate: state.alternativesTemplateOptions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadProducts: () => dispatch(calculatorActions.loadProducts()),
    onLoadTemplates: calculatorID =>
      dispatch(calculatorActions.loadTemplates(calculatorID)),
    onLoadCurrentTemplateProducts: templateID =>
      dispatch(calculatorActions.loadTemplateProducts(templateID)),
    onLoadAlternativeOptions: templateID =>
      dispatch(calculatorActions.loadAlternativeOptions(templateID)),
    onUpdateCurrentTemplateProducts: (altProductID, posToReplace) =>
      dispatch({
        type: actionTypes.UPDATE_CURRENTTEMPLATEPRODUCTS,
        alternativeProductID: altProductID,
        positionToReplace: posToReplace
      }),
    onLoadAlternativeOptionsTemplate: templateID =>
      dispatch(calculatorActions.loadAlternativeOptionsTemplate(templateID)),
    onUpdateCurrentTemplateOptions: (altProductID, posToReplace) =>
      dispatch({
        type: actionTypes.UPDATE_CURRENTTEMPLATEOPTIONS,
        alternativeProductID: altProductID,
        positionToReplace: posToReplace
      })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calculator);
